import React from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../Sidebar'
import className from 'classnames'
import ServerBanner from '../ServerBanner'

const PageContent = ({children, isLoggedIn, isSidebarOpen}) => {
	if(isLoggedIn){
		return (
			<div className="container-fluid extra-container-padding">
				<div className={className("row row-offcanvas row-offcanvas-left", {active: isSidebarOpen})}>
					<Sidebar />
					<div className="col-xs-12 col-sm-9 col-lg-10 content-area">
						<ServerBanner key="banners"/>
						{children}
					</div>
				</div>
			</div>
		)
	}else{
		return (
			<main className='col-xs-12 col-sm-6 col-sm-offset-3 col-md-5 col-md-offset-4 col-lg-4 col-lg-offset-4 content-area login-page'>
				<ServerBanner key="banners"/>
				{children}
			</main>
		)
	}
}

PageContent.propTypes = {
	children: PropTypes.any,
	isLoggedIn: PropTypes.bool,
	isSidebarOpen: PropTypes.bool
}

export default PageContent



// WEBPACK FOOTER //
// ./client/components/layout/PageContent/index.js